import constants from '@/ctConstants.js';
import i18n from '@/i18n';

const NAME_USER_SESSION = "ctSessionUser";

export default {
    data: () => ({
        dialogMsgOpen: false,
        dialogMsg: "",
    }),
    methods: {
        
        //=== UTILITY
        isEmptyString: function (str) {
            return (str == null || str == undefined || str.length === 0);
        },
        isEmptyObj: function (str) {
            return (str == null || str == undefined);
        },
        formatPrice(value) 
        {
			let val = (value/1).toFixed(2).replace('.', ',')
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
		},
        formatTimestamp(value) 
        {
			try {	
				// 2018-12-21T08:56:37.880Z
				var year = value.substr(0, 4);
				var month = value.substr(5, 2);
				var day = value.substr(8, 2);
				var hours = value.substr(11, 2);
				var minutes = value.substr(14, 2);
				var seconds = value.substr(17, 2);
				
				var result = day + "/" + month  + "/" + year + " " + hours +":"+minutes+ ":"+seconds;
				return result;
			} catch(err) {
				return "";
			}
        },
        formatUnixTime(value) 
        {
			try {	
                var a = new Date(value);
                var year = a.getFullYear();
                //var month = (a.getMonth()+1).toStr.padStart(4,'0');
                var month =  this.pad_left(''+ (a.getMonth() +1 ), 2, '0') ;
                var date = a.getDate();
                var hour = a.getHours();
                var min = a.getMinutes();
                var sec = a.getSeconds();
                var result = date + '/' + month + '/' + year + ' ' + hour + ':' + min + ':' + sec ;
                return result;
			} catch(err) {
				return "";
			}
        },
        setDialogMsg(msg) { 
            this.dialogMsg = msg; 
            this.dialogMsgOpen = true;
        },
        findTranslationInList(transList){
            return transList[i18n.locale];
        },
        pad_left(my_string, length, char2add) 
        {
            while (my_string.length < length) {
                my_string = char2add + my_string;
            }
            return my_string;
        },
        //=== AUTHENTICATION
        checkAuthorizedOnApp: function (user2check, codApp) { 
            if(!this.isEmptyObj(user2check) && !this.isEmptyObj(user2check.Applications) && !this.isEmptyString(codApp))
            {
                for (var i = 0; i < user2check.Applications.length; i++) 
                {
                    var appTmp = user2check.Applications[i];
                    if(!this.isEmptyObj(appTmp) && !this.isEmptyString(appTmp.ID))
                    {
                        if(appTmp.ID.toLowerCase().trim() == codApp.toLowerCase().trim())
                        {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        //=== UTENTI
        setUser: function (user) {
            this.setUserBySessionKey(user, NAME_USER_SESSION);
        },
        setUserBySessionKey: function (user, sessionKey) {
            //console.log("setUser: " + user);  
            if(user == null){
                localStorage.removeItem(sessionKey);
            } else {
                localStorage.setItem(sessionKey, JSON.stringify(user));
            }
        },
        getUser: function () {
            return this.getUserBySessionKey(NAME_USER_SESSION);
        },
        getUserAccessToken: function () {
			return  this.getUser().AuthenticationResult.AccessToken; 
        },
        getUserBySessionKey: function (sessionKey) {
            //console.log("getUserByStorage: " +sessionKey);
            try {
                return JSON.parse(localStorage.getItem(sessionKey));
            } catch(err) {
                return null;
            }
        },
        getMyAuthHeader(myUser){ 
            // La parola Bearer deve iniziare con la maiuscola altrimenti abbiamo problema CORS
			return {headers: {'Authorization': "Bearer " +  myUser.AuthenticationResult.AccessToken} }; 
        },
        //=== EMPTY ENTITY
        getEmptyProject(){
			var obj =  { 
				"project_name": {
					"en_US": "",
					"it_IT": ""
				},
				"project_description": {
					"en_US": "",
					"it_IT": ""
				},
			}
			return obj;	
        },
        getEmptyOrgGuiAdmin(){
            var obj =  { 
                organization_id:'',
                organization_name:'',
                logo: ''
            }
            return obj;
        },
        getEmptySite(){
			var obj =  { 
				"site_name": '',
				"description": '',
                "site_category": '',
                "site_location": {
					latitude:0, 
					longitude:0, 
					altitude: 0
				},
                "flags": {
                    "active": false
                },
			}
			return obj;	
        },
        getSecureSiteList(list, onlyActive)
        {
            var results = [];
            for (var i = 0; i < list.length; i++) 
            {
                var secureObjTmp = this.getSecureSiteByAwsObj(list[i]);
                if(onlyActive){
                    if(!this.isEmptyObj(secureObjTmp.flags) && secureObjTmp.flags.active == true)
                    {
                        results.push(secureObjTmp);
                    }
                } else {
                   results.push(secureObjTmp);
                }
                
            }
            return results;
        },
        getSecureSiteByAwsObj(siteByAws)
        {
            var obj = siteByAws;
            if(this.isEmptyObj(obj.site_location))
            {
                obj.site_location = {
					latitude:0, 
					longitude:0, 
					altitude: 0
				};
            }
            if(this.isEmptyObj(obj.flags))
            {
                obj.flags = {
                    "active": false
                };
            }
			return obj;	
        }, 
        getEmptyMap(){
			var obj =  {
				map_asset: '',
				map_asset_type: '',
                map_name: '',
                map_link: '',
                map_db_mask_code: '',
                main_obj_pos_x: 0,
                main_obj_pos_y: 0,
                main_obj_pos_z: 0,
                main_obj_scale_x: 0,
                main_obj_scale_y: 0,
                main_obj_scale_z: 0,
                main_obj_rotation_x: 0,
                main_obj_rotation_y: 0,
                main_obj_rotation_z: 0,
                flags: {
                    "active": false
                },
			};
			return obj;	
        },
        getSecureMapList(list, onlyActive)
        {
            var results = [];
            for (var i = 0; i < list.length; i++) 
            {
                var secureObjTmp = this.getSecureMapByAwsObj(list[i]);
                if(onlyActive){
                    if(!this.isEmptyObj(secureObjTmp.flags) && secureObjTmp.flags.active == true)
                    {
                        results.push(secureObjTmp);
                    }
                } else {
                   results.push(secureObjTmp);
                }
                
            }
            return results;
        },
        getSecureMapByAwsObj(mapByAws)
        {
            var obj = mapByAws;
            if(this.isEmptyString(obj.map_link)){
                obj.map_link = '';
            }
            if(this.isEmptyString(obj.map_db_mask_code)){
                obj.map_db_mask_code = '';
            }
            if(this.isEmptyObj(obj.flags))
            {
                obj.flags = {
                    "active": false
                };
            }
			return obj;	
        },
        getEmptyPoiObj()
        {
            //"sitemap_id": "",
            var obj = {
                "background_image": "",
                "shape": "circle",
                "things": [],
                "thumbnail": "",
                "transform": {
                    "position": {
                        "x": 0,
                        "y": 0,
                        "z": 0
                    },
                    "rotation": {
                        "x": 0,
                        "y": 0,
                        "z": 0,
                        "w": 0
                    },
                    "scale": {
                        "x": 0,
                        "y": 0,
                        "z": 0
                    }
                },
                "flags": {
                    "active": false
                },
            }
            //=== ADD A FIRST AND UNIQUE THING 
			obj.things.push(this.getEmptyThingObj());
            return obj;
        },
        getSecurePoiList(list, onlyActive)
        {
            var results = [];
            for (var i = 0; i < list.length; i++) 
            {
                var secureObjTmp = this.getSecurePoiByAwsObj(list[i]);
                if(onlyActive){
                    if(!this.isEmptyObj(secureObjTmp.flags) && secureObjTmp.flags.active == true)
                    {
                        results.push(secureObjTmp);
                    }
                } else {
                   results.push(secureObjTmp);
                }
                
            }
            return results;
        }, 
        getSecurePoiByAwsObj(poiByAws)
        {
            var obj = poiByAws;
            if(this.isEmptyObj(obj.flags))
            {
                obj.flags = {
                    "active": false
                };
            }
            if(this.isEmptyObj(obj.transform))
            {
                obj.transform =  {
                    "position": {
                        "x": 0,
                        "y": 0,
                        "z": 0
                    },
                    "rotation": {
                        "x": 0,
                        "y": 0,
                        "z": 0,
                        "w": 0
                    },
                    "scale": {
                        "x": 0,
                        "y": 0,
                        "z": 0
                    }
                }
            }
            if(this.isEmptyObj(obj.things))
            {
                obj.things = [];
                obj.things.push(this.getEmptyThingObj());
            }
            else
            {
                for (var i = 0; i < obj.things.length; i++) 
                {
                    if(this.isEmptyObj(obj.things[i]) == false)
                    {
                        if(this.isEmptyObj(obj.things[i].mock_data)== false)
                        {
                            // RIMUVO MOC_DATA SE FOSSE PRESENTE
                            delete obj.things[i].mock_data
                        }
                    }
                }
            }
			return obj;	
        },
        getEmptyThingObj()
        {
            var obj = {
                "service_id": "",
                "thing_id": "",
                "thing_name": "",
                "thing_link": "",
                "type": ""
            }
            return obj;
        },
        getEmptyCartElement(){
			var obj =  { 
                "service_id": null, 
				"service": null,
                "notes": {
                    "it_IT": ""
                },
                "contents_data":{}
			}
			return obj;	
        },
        getEmptyEstimateObj(){
            var obj =  {num_services:0, amounts: {}};
            return obj;	
        },
        findServiceObjInCatalogue(serviceId, servicesList)
		{
			for (var i = 0; i < servicesList.length; i++) 
			{
				var serviceObj = servicesList[i];	
				
				if(serviceObj.service_id == serviceId)
				{
					return serviceObj;
				}
			}
			return null;
		},	
        getSiteCategoryItems()
		{
			var results = [
                {value: "building", text: "building"},
                {value: "machinery", text: "machinery"},
            ]
            return results;
        },
        getMapAssetTypeItems()
		{
			var results = [
                {value: "only_values", text: "Only Values"},
                {value: "image", text: "Image"},
                {value: "render3d_basic", text: "Render3D Basic"},
                {value: "render3d_pro", text: "Render3D Pro"},
                {value: "threejs", text: "Three js"},
                
            ]
            return results;
        },
        decodeMapAssetType(value)
		{
            var result = '';
            if(!this.isEmptyString(value))
            {
                if(value == "only_values") {
                    result = "Only Values";
                } else if(value == "image") {
                    result = "Image";
                } else if(value == "render3d_basic") {
                    result = "Render3D Basic";
                } else if(value == "render3d_pro") {   
                    result = "Render3D Pro";
                } else if(value == "threejs") {
                    result = "Three js";  
                }
            } 
            return result;
        },
        getPoiShapeItems()
		{
			var results = [
                {value: "circle", text: "Circle"}
            ]
            return results;
        },
        getActiveList(list){
            return list;
        },  
        calculateEstimate(services, catalogueServiceList, flgFindObjectByCatalgue)
        {
            var estimate_obj = this.getEmptyEstimateObj();
            try{
                if(!this.isEmptyObj(services) && services.length > 0 && !this.isEmptyObj(catalogueServiceList) && catalogueServiceList.length > 0 )
                {
                    for (var i = 0; i < services.length; i++) 
                    {
                        var serviceInCart = services[i];
                        if(!this.isEmptyObj(serviceInCart))
                        {
                            estimate_obj.num_services += 1;
                            
                            
                            var serviceObjWithInfo = null;
                            if(flgFindObjectByCatalgue == false)
                            {
                                // PRENDO OGGETTO SERVIZIO DALLA LISTA IN INPUT
                                serviceObjWithInfo = serviceInCart.service;
                            } else {
                                // PPRENDO OGGETTO SERVIZIO DAL CATALOGO
                                serviceObjWithInfo = this.findServiceObjInCatalogue(serviceInCart.service_id, catalogueServiceList);
                            }
                            if(!this.isEmptyObj(serviceObjWithInfo) && !this.isEmptyObj(serviceObjWithInfo.contents))
                            {
                                for(var namecontent in serviceObjWithInfo.contents)
                                {
                                    var serviceContentInCatalog = serviceObjWithInfo.contents[namecontent];
                                    var contentQty = this.getQuantityServiceContentByServiceObjWithContentData(serviceInCart, namecontent, null, 0);
                                    var contentPeriod = serviceContentInCatalog.period;
                                    var contentCurrency = serviceContentInCatalog.price.currency
                                    var contentPrice = serviceContentInCatalog.price.value;
                                    if(!contentPeriod)
                                    {
                                        if(this.isEmptyObj(estimate_obj.amounts.not_periodic))
                                        {
                                            estimate_obj.amounts.not_periodic = {};
                                        }
                                        if(this.isEmptyString(estimate_obj.amounts.not_periodic[contentCurrency]))
                                        {
                                            estimate_obj.amounts.not_periodic[contentCurrency] = 0;   
                                        }

                                        estimate_obj.amounts.not_periodic[contentCurrency]  += (contentQty * contentPrice);
                                    } 
                                    else 
                                    {
                                        if(this.isEmptyObj(estimate_obj.amounts[contentPeriod]))
                                        {
                                            estimate_obj.amounts[contentPeriod] = {};
                                        }
                                        if(this.isEmptyString(estimate_obj.amounts[contentPeriod][contentCurrency]))
                                        {
                                            estimate_obj.amounts[contentPeriod][contentCurrency] = 0;   
                                        }

                                        estimate_obj.amounts[contentPeriod][contentCurrency] += (contentQty * contentPrice);
                                    }

                                    //=== CICLO ADDITIONAL CONTENTS
                                    if(!this.isEmptyObj(serviceContentInCatalog) && !this.isEmptyObj(serviceContentInCatalog.additional_contents))
                                    {
                                        for(var nameadditionalcontent in serviceContentInCatalog.additional_contents)
                                        {
                                            var serviceAdditionalContentInCatalog = serviceContentInCatalog.additional_contents[nameadditionalcontent];
                                            var additionalContentQty = this.getQuantityServiceContentByServiceObjWithContentData(serviceInCart, namecontent, nameadditionalcontent, 0);
                                            var additionalContentPeriod = serviceAdditionalContentInCatalog.period;
                                            var additionalContentCurrency = serviceAdditionalContentInCatalog.price.currency
                                            var additionalContentPrice = serviceAdditionalContentInCatalog.price.value;
                                    
                                            if(!additionalContentPeriod)
                                            {
                                                if(this.isEmptyObj(estimate_obj.amounts.not_periodic))
                                                {
                                                    estimate_obj.amounts.not_periodic = {};
                                                }
                                                if(this.isEmptyString(estimate_obj.amounts.not_periodic[additionalContentCurrency]))
                                                {
                                                    estimate_obj.amounts.not_periodic[additionalContentCurrency] = 0;   
                                                }
                                                estimate_obj.amounts.not_periodic[additionalContentCurrency]   += (additionalContentQty * additionalContentPrice);
                                            } 
                                            else 
                                            {
                                                if(this.isEmptyObj(estimate_obj.amounts[additionalContentPeriod]))
                                                {
                                                    estimate_obj.amounts[additionalContentPeriod] = {};
                                                }
                                                if(this.isEmptyString(estimate_obj.amounts[additionalContentPeriod][additionalContentCurrency]))
                                                {
                                                    estimate_obj.amounts[additionalContentPeriod][additionalContentCurrency] = 0;   
                                                }
                                                estimate_obj.amounts[additionalContentPeriod][additionalContentCurrency]   += (additionalContentQty * additionalContentPrice);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } catch(err) {
                console.log(err);
            }
            return estimate_obj;
        }, 
        getQuantityServiceContentByServiceObjWithContentData(serviceObjWithCD, namecontent, additionalnamecontent, defaultqty)
		{
            if(!this.isEmptyObj(serviceObjWithCD) && !this.isEmptyObj(serviceObjWithCD.contents_data))
            { 
                if(!this.isEmptyString(namecontent))
                {
                    var dataMyContentTmp = serviceObjWithCD.contents_data[namecontent];
                    if(!this.isEmptyObj(dataMyContentTmp))
                    {
                        if(!this.isEmptyString(additionalnamecontent))
                        {
                            //=== DEVO RESTITUIRE LA QUANTITA DEL ADDITIONAL CONTENT
                            var dataMyAdditionalContentTmp = dataMyContentTmp[additionalnamecontent];
                            if(!this.isEmptyObj(dataMyAdditionalContentTmp))
                            {
                                if(!this.isEmptyString(dataMyAdditionalContentTmp.quantity))
                                {
                                    return dataMyAdditionalContentTmp.quantity;      
                                } 
                                else 
                                {
                                    //=== QUANTITA NON PRESENTE
                                    return defaultqty;
                                }       
                            } 
                            else 
                            {
                                //=== ADDITIONAL CONTENT NON PRESENTE
                                return defaultqty;
                            }    
                        } 
                        else 
                        {
                            //=== DEVO RESTITUIRE LA QUANTITA DEL CONTENT
                            if(!this.isEmptyString(dataMyContentTmp.quantity))
                            {    
                                return dataMyContentTmp.quantity; 
                            } 
                            else 
                            {
                                //=== QUANTITA NON PRESENTE
                                return defaultqty;
                            }
                        }  
                    } 
                    else 
                    {
                        //=== CONTENT NON PRESENTE
                        return defaultqty;
                    }
                } 
                else 
                {
                    //=== INPUT NAME CONTENT NON PRESENTE
                    return defaultqty;
                }
            } 
            else 
            {
                //=== OGGETTO DI RIFERIMENTO NULLO O SENZA CONTENT DATA
                return defaultqty;
            }
        }
    }
}